
import { useNavigate } from 'react-router-dom';
import { useBoardContext } from '@/contexts/BoardContext';

export const useCardNavigation = () => {
  const navigate = useNavigate();
  const { setCurrentBoardId, allColumns } = useBoardContext();

  const navigateToCard = (cardId: string, columnId: string) => {
    // Find the board ID from the column
    const column = allColumns?.find(col => col.id === columnId);
    if (!column) {
      console.error('Column not found for card navigation');
      return;
    }

    // Set the current board
    setCurrentBoardId(column.board_id);
    
    // Navigate to the main kanban board view with card ID in URL
    navigate(`/?card=${cardId}`);
  };

  return { navigateToCard };
};
